import {
  buildBrowserAtomicPositionProof,
  type BrowserAtomicPositionProof,
  type BrowserAtomicPositionProofInput,
  type BrowserEngineArtifact,
} from "@chessla/shared";

export type AtomicPositionProof = BrowserAtomicPositionProof;
export const buildAtomicPositionProof = (input: BrowserAtomicPositionProofInput): AtomicPositionProof =>
  buildBrowserAtomicPositionProof(input);

export const withAtomicPositionProof = (artifact: BrowserEngineArtifact): BrowserEngineArtifact => ({
  ...artifact,
  atomicProof: buildBrowserAtomicPositionProof({
    fen: artifact.source.fen,
    perspective: artifact.source.playerColor,
    lines: artifact.lines,
  }),
});
